import { isMobile } from "react-device-detect";
import Translate from "@identitybuilding/idb-react-translations";

const punycode = require("punycode/");

let host = window.location.hostname;
host = host.replace("www.", "");
// Filter out frontend and migration prefixes early
host = host
  .replace(/^frontend\./, "") // "migration.ondernemersnetwerk.be"
  .replace(/^migration\./, ""); // "ondernemersnetwerk.be"

let devMode = false;
const hostParts = host.split('.');
// hostParts.includes('migration') ---> removed this from OR condition to remove "DEV-MODE" tag from UI
if (host.includes(".dev")) {
  devMode = true;
}

// console.log("Current host:", host);

// Normalize IP address or specific domains to 'localhost'
// if (
//   /^\d{1,3}(\.\d{1,3}){3}$/.test(host) || // Check for IP address format
//   host === "osnfrontendwithmultiplemapselectionfeature.netlify.app" // Check for specific domain
// ) {
//   host = "localhost";
// }
// Split the host into parts
let parts = host.match(/([a-z0-9|-]+)/g); // ["ondernemersnetwerk", "be"]

// Determine subdomain
let subdomain = "";
if (parts.length === 3 || parts.length === 4) {
  // If there's a subdomain before the main domain (not frontend/migration)
  subdomain = parts[0].toLowerCase(); // Would need a real subdomain in URL
}


// The Switch to get the 100procentlokaal Website or Ondernemersnetwerk Website on localhost 
// If a developer uncomment this subdomain with a municipality name then 100procentlokaal will be opened 
// Else if it commented then it will open Ondernemersnetwerk Website
// subdomain = "erpe-mere"

// Determine domain
let domain = host
  .replace(/^www\./, "")
  .replace(/^frontend\./, "")
  .replace(/^migration\./, "")
  .replace(/\.frontend/g, "")
  .replace(/\.migration/g, "")
  .match(/([a-z0-9|-]+)/g);
domain =
  domain.length === 2 || domain.length === 1
    ? domain[0].toLowerCase()
    : domain.length === 3
      ? domain[1].toLowerCase()
      : domain[2] && domain[2].toLowerCase();

// get the decoded punycode name
let decoded_subdomain = punycode.toUnicode(subdomain);
subdomain = decoded_subdomain

// Language detection
let lang =
  host.includes("ondernemersnetwerk") || host.includes("100procentlokaal")
    ? "nl"
    : host.includes("reseauentrepreneurs") || host.includes("100pourcentlocale")
      ? "fr"
      : host.includes("entrepreneursnetwork")
        ? "en"
        : "nl";

// Translation slugs
const search_slug = Translate("search_slug", lang);
const page_slug = Translate("page", lang).toLowerCase();
const initialState = {
  lang: lang,
  translate: (x) => Translate(x, lang),
  device: isMobile ? "mobile" : "desktop",
  nis: subdomain,
  decoded_nis: decoded_subdomain,
  dev: devMode,
  domain: domain,
  search_path: (location, keyword, page, keyboard, as, filter) => {
    let loc = "";

    if (typeof location === "object") {
      if (location.length === 1) {
        if (location[0].slug === subdomain) {
          loc = false;
        } else {
          loc = location[0].slug;
        }
      } else {
        loc = location.map((loc) => loc.slug);
      }
    } else {
      loc = location;
    }
    return `/${search_slug}${loc ? `/${loc}` : ""}${keyword ? `/${keyword}` : ""
      }${page ? `/${page_slug}=${page}` : ""}${as ? `?category=${as}` : ""}${filter && filter.length > 0 ? `${as ? "&" : "?"}service=${filter}` : ""
      }`;
  },
};

const GeneralReducer = (state = initialState, action) => state;

export default GeneralReducer;
